import { ref, onUnmounted, getCurrentInstance } from 'vue'
import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

export function useWebsocket() {
  const config = useRuntimeConfig();
  const isConnected = ref(false)
  const echo = ref<Echo | null>(null)

  const connect = () => {
    if (typeof window === 'undefined') return null
    window.Pusher = Pusher

    if (echo.value) return echo.value

    const host = config.public.wsHost === '0.0.0.0' ? window.location.hostname : config.public.wsHost
    const isHttps = config.public.reverbScheme === 'https' || window.location.protocol === 'https:'
    const broadcaster = isHttps ? 'reverb' : 'pusher';

    echo.value = new Echo({
      broadcaster: broadcaster,
      key: config.public.wskey,
      wsHost: host,
      wsPort: Number(config.public.wsPort) || 8080,
      wssPort: Number(config.public.wssPort) || 8080,
      forceTLS: isHttps,
      enabledTransports: ['ws', 'wss'],
      disableStats: true,
      cluster: 'mt1'
    })

    echo.value.connector.pusher.connection.bind('connected', () => {
      isConnected.value = true
      console.log('✅ WebSocket connected')
    })
    echo.value.connector.pusher.connection.bind('disconnected', () => {
      isConnected.value = false
      console.log('❌ WebSocket disconnected')
    })
    echo.value.connector.pusher.connection.bind('error', (err: any) => {
      console.error('⚠️ Pusher error:', err)
    })

    return echo.value
  }

  const disconnect = () => {
    if (echo.value) {
      echo.value.disconnect()
      echo.value = null
      isConnected.value = false
    }
  }

  if (getCurrentInstance()) {
    onUnmounted(disconnect)
  }

  return { connect, disconnect, isConnected, echo }
}
